module.exports = __webpack_public_path__ + "static/media/point_icon.c3dc34f3.svg";